export default __webpack_public_path__ + "static/media/prohibited.472e6897.svg";